module.exports = __webpack_public_path__ + "img/30273.88788024.png";